module.exports = __webpack_public_path__ + "static/media/tropadeleet.b097d472.svg";